import { observable } from "mobx";
import React from "react";
import { pluginComponentStore } from "../WSUtils/PluginComponents";

const LoginModal = React.lazy(() => import("./LoginModal"));

export const showLoginModal = () => {
  if (isLoginModalShowing()) return;

  pluginComponentStore.add(LoginModal, loginModalKey);
};

export const isLoginModalShowing = () =>
  pluginComponentStore.indexOfKey(loginModalKey) !== -1;

export const loginModalKey = "loginModalKey";

export const loginCardsShowing = observable.map<string, true>();

export const isLoginCardShowing = () => loginCardsShowing.size > 0;
